export enum AppType {
	hook = 'hook-processor',
	data = 'data',
	event = 'event',
	cdnExport = 'cdn-export',
	contentEngine = 'ce',
}

export enum ParameterType {
	text = 'text',
	select = 'select',
}

// Content Engine integration slugs (matching backend Integration.php constants)
export const CONTENT_ENGINE_APP_SLUGS = [
	'storyblok-ce',
	'braze-ce',
	'marketo',
	'freshdesk',
	'typeform',
	'iterable',
	'youtube',
	'smc',
	'googleplay',
	'ditto',
	'webflow',
	'clevertap',
	'moengage',
	'customerio',
] as const

export type ContentEngineAppSlug = (typeof CONTENT_ENGINE_APP_SLUGS)[number]

// Helper function for validation at system boundaries (no heavy dependencies)
export const isValidContentEngineAppSlug = (slug: unknown): slug is ContentEngineAppSlug => {
	return typeof slug === 'string' && CONTENT_ENGINE_APP_SLUGS.includes(slug as ContentEngineAppSlug)
}

export type AppInfo = {
	title: string
	slug: ContentEngineAppSlug
	logo: string
	logoDarkmode: string | undefined
}
